import { Box } from "@mui/material";
import { format } from "date-fns";
import { t } from "i18next";
import BaseTable from "../../../components/table/BaseTable";
import { useProductBookings } from "../../../services/bookingsService";
import { BookingStatusText } from "../../BookingPage/BookingStatusText";

const HEADERS = [
    t("products.ProductPassportBookingTable.startDate"),
    t("products.ProductPassportBookingTable.endDate"),
    t("products.ProductPassportBookingTable.status"),
    t("products.ProductPassportBookingTable.customer"),
    t("products.ProductPassportBookingTable.creator"),
];

export function ProductPassportBookingsTable(props) {
    const { data: productBookings } = useProductBookings(props.productId, {
        select: (data) =>
            data?.results?.map((booking) => {
                // Get customer info for display
                const customerName = booking.customers
                    .map((bc) =>
                        bc.customer
                            ? bc.customer.company 
                                ? bc.customer.company.name_short 
                                : `${bc.customer.person?.name || ""} ${bc.customer.person?.surname || ""}`.trim()
                            : "-",
                    )
                    .join("\n");

                return {
                    rowId: booking.id,
                    data: [
                        format(new Date(booking.start), "yyyy-MM-dd"),
                        format(new Date(booking.end), "yyyy-MM-dd"),
                        <BookingStatusText status={booking.status} />,
                        customerName,
                        booking.creator,
                    ],
                };
            }) || [],
    });

    return (
        <Box sx={{ maxHeight: 200, overflow: "auto", borderRadius: 1 }}>
            <BaseTable
                stickyHeader={true}
                headers={HEADERS}
                rows={productBookings || []}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                // ensure no columns are hidden
                hiddenColumns={[]}
                // no row selection for this static table
                selectedRows={[]}
            />
        </Box>
    );
}
